module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div data-id=\"")
    ; __append(escapeFn( filter.id ))
    ; __append("\" class=\"")
    ; __append(escapeFn( filter.class ))
    ; __append("\">\n    <label>\n        <label class=\"empty-control-label\">\n            <input data-filter-id=\"")
    ; __append(escapeFn( filter.id ))
    ; __append("\" name=\"empty-control\" type=\"checkbox\"/>\n            не указан\n        </label>        <!--<span class=\"title\">")
    ; __append(escapeFn( filter.title ))
    ; __append("</span><br/>-->\n        <control ")
    ; __append( Html.attributes(filter) )
    ; __append(" />\n    </label>\n</div>\n")
  }
  return __output.join("");

}